<template>
  <div class="right-content">
    <a-spin :spinning="loading">
      <template v-if="!!data">
        <header class="header">
          <div class="header_title">
            {{ moment(data.createAt).format('YYYY.MM.DD HH:mm') }}
            <span class="createName">{{ data.createBy }}</span>
            上传
            <span v-if="isTraceRecordShow" @click="handleHistory" class="history">
              查看历史核验结果
              <RightOutlined
                :style="{ marginLeft: '2px', fontSize: '12px', verticalAlign: 'baseline' }"
              />
            </span>
          </div>
          <div class="header-img">
            <img
              v-if="data.doctorPermission"
              :width="124"
              :height="44"
              :src="VisibleDoctor"
              alt="医生可见"
              class="visible_img"
            />
            <img
              v-else
              class="visible_img"
              :width="124"
              :height="44"
              :src="VisibleDoctorNo"
              alt="医生不可见"
            />
            <img
              v-if="data.patientPermission"
              :width="124"
              :height="44"
              :src="VisiblePatient"
              alt="患者可见"
            />
            <img v-else :width="124" :height="44" :src="VisiblePatientNo" alt="患者不可见" />
          </div>
        </header>
        <div class="body">
          <!-- 通用 -->
          <TheContent title="诊断/证型" class="project">
            <div class="diagnosis-pattern">
              <span class="label">就诊时间:</span>
              <span class="value" v-if="data.diagnosisList">
                {{ data?.inquiryTime }}
              </span>
              <span class="value" v-else>--</span>
            </div>
            <div class="diagnosis-pattern">
              <span class="label">诊断:</span>
              <span class="value">{{ data?.offlineDiagnosis || '--' }}</span>
            </div>
          </TheContent>
          <!-- 处方信息 -->
          <TheContent title="处方信息" class="project">
            <template v-if="data.medicationNames && data.medicationNames.length">
              <div
                class="offline"
                v-for="(medicationName, index) in data.medicationNames"
                :key="index"
              >
                <div class="item large">
                  <label class="label">药品名称:</label>
                  <span class="value">
                    {{ medicationName || '--' }}
                  </span>
                </div>
                <div class="item">
                  <label class="label">用药周期：</label>
                  <span class="value" v-if="data.prescriptionInfo?.medicineCycle">
                    周期 {{ data.prescriptionInfo?.medicineCycle }} 天
                  </span>
                  <span v-else>--</span>
                </div>
                <div class="item">
                  <label class="label">用药时间：</label>
                  <span class="value">{{ data.prescriptionInfo?.beginTime || '--' }}</span>
                </div>
                <div class="item">
                  <label class="label">结束用药时间：</label>
                  <span class="value">
                    <span>
                      {{ data.prescriptionInfo?.endTime || '--' }}
                    </span>
                    <span v-if="data.prescriptionInfo?.endWeek">
                      ( {{ data.prescriptionInfo?.endWeek || '--' }})
                    </span>
                  </span>
                </div>
              </div>
            </template>
            <EmptyText v-else></EmptyText>
          </TheContent>
          <!-- 门诊就诊才有 -->
          <TheContent title="病情描述" class="project">
            <div class="MedicalHistory-text">
              {{ data.description || '--' }}
            </div>
          </TheContent>
          <!-- 通用 -->
          <TheContent title="复诊预约" class="project">
            <div class="Followup-Appointment">
              <div
                v-if="[1, 2].includes(data.cureReserveOrderVO?.revisitType)"
                class="Followup-item"
              >
                <div class="left-text">
                  <span>{{ `${data.cureReserveOrderVO.reserveDateStr}` }}｜</span>
                  <!-- 线上、线下问诊 -->
                  <span>{{ `${treatWay[data.cureReserveOrderVO?.revisitType]}` }}</span>
                </div>
                <!--  -->
                <div @click="openRevisit" class="right-text">
                  {{ config.RESERCE_STATE_MAP[data.cureReserveOrderVO?.reserveState] }}
                  <RightOutlined />
                </div>
              </div>
              <div v-else class="Followup-item">遵医嘱复诊</div>
            </div>
          </TheContent>
          <!-- 线下门诊 -->
          <TheContent :showDivider="false" title="病历图片" class="project">
            <div class="imgs" v-if="data?.imgUrlList && data?.imgUrlList.length">
              <a-image-preview-group>
                <a-image
                  class="img"
                  :fallbackImg="fallbackImg"
                  v-for="img in data.imgUrlList"
                  :key="img.businessId"
                  :width="80"
                  :height="80"
                  :src="img.filePath"
                />
              </a-image-preview-group>
            </div>
            <EmptyText v-else></EmptyText>
          </TheContent>
        </div>
      </template>
      <EmptyText v-else></EmptyText>
    </a-spin>
    <!-- 复诊预约详情 -->
    <ADetail ref="aDetail" :recordId="appointId" />
    <!-- 查看历史溯源码 -->
    <DrugTraceRecord ref="DrugTraceRecordRef" :list="traceRecordsList" />
  </div>
</template>

<script setup>
import VisibleDoctor from '@/assets/img/PatientFile/Visible-doctor.png'
import VisibleDoctorNo from '@/assets/img/PatientFile/Visible-doctor-no.png'
import VisiblePatientNo from '@/assets/img/PatientFile/Visible-patient-no.png'
import VisiblePatient from '@/assets/img/PatientFile/Visible-patient.png'

import ADetail from '@/views/WorkPlace/components/Appoint/index.vue'
import TheContent from './components/TheContent.vue'
import { computed, nextTick, ref, watch } from 'vue'
import fallbackImg from '@/assets/img/img-err.png'
import { RightOutlined } from '@ant-design/icons-vue'
import { judgeTraceRecords, listTraceRecords, offLineRecordDetail } from '@/api/HealthRecord'
import { useStore } from 'vuex'
import moment from 'moment'
import config from '@/config/index'
import EmptyText from '@/components/PatientFile/EmptyText.vue'
import DrugTraceRecord from '@/components/DrugTraceRecord/index.vue'
const treatWay = {
  1: '线上问诊',
  2: '门诊就诊'
}
const store = useStore()
const diagnosisPattern = computed(() => store.state.patientFile.diagnosisPattern)
const data = ref({})
const loading = ref(false)
// 处方药品追溯码记录
const traceRecordsList = ref([])
// 核验历史按钮是否展示
const isTraceRecordShow = ref(false)
const DrugTraceRecordRef = ref(null)
function getDate(businessId) {
  // console.log('businessId', businessId)
  const params = {
    id: businessId //'69537ec5172340000d98b944'
  }
  loading.value = true
  offLineRecordDetail(params)
    .then(result => {
      // console.log(result)
      data.value = result
    })
    .finally(() => {
      loading.value = false
    })
}
const aDetail = ref('')
const appointId = ref('')
// 打复诊预约
function openRevisit() {
  appointId.value = data.value.reserveId
  nextTick(() => {
    aDetail.value.mVisible = true
    aDetail.value.initDetail()
  })
}

// 判断该处方是否上传过药品追溯码
const hasTraceRecord = async () => {
  try {
    const res = await judgeTraceRecords({ prescriptionCode: data.value.offlineSerialNumber })
    if (res) {
      const listRes = await listTraceRecords({ prescriptionCode: data.value.offlineSerialNumber })
      traceRecordsList.value = listRes || []
      isTraceRecordShow.value = true
    } else {
      isTraceRecordShow.value = false
      traceRecordsList.value = []
    }
  } catch (error) {
    console.log('Error fetching trace records:', error)
  }
}

const handleHistory = () => {
  DrugTraceRecordRef.value.setVisible(true)
}

watch(
  () => data.value,
  val => {
    if (val && val.offlineSerialNumber) {
      hasTraceRecord()
    }
  },
  {
    deep: true,
    immediate: true
  }
)

watch(
  () => diagnosisPattern.value.businessId,
  businessId => {
    if (!businessId) return
    getDate(businessId)
  },
  {
    immediate: true
  }
)
</script>

<style lang="scss" scoped>
.right-content {
  .header {
    display: flex;
    justify-content: space-between;
    .header_title {
      font-size: 14px;
      color: #999999;
      font-weight: 400;
      height: 16px;
      display: flex;
      align-items: center;
      .createName {
        margin: 0 2px;
      }
      .history {
        font-size: 14px;
        margin-left: 8px;
        color: #014ea8;
        display: flex;
        align-items: center;
        cursor: pointer;
      }
    }
    .header-img {
      margin-right: 32px;
      .visible_img {
        margin-right: 12px;
      }
    }
  }
  .body {
    .project {
      &:last-child {
        margin-bottom: 0;
      }
      .diagnosis-pattern {
        margin-bottom: 16px;
        &:last-child {
          margin-bottom: 0;
        }
        .label {
          color: #999999;
          font-size: 14px;
          font-weight: 500;
          margin-right: 8px;
          width: 62px;
          display: inline-block;
          text-align: right;
        }
        .value {
          color: #333333;
          font-size: 14px;
          font-weight: 500;
        }
      }
      .MedicalHistory-text {
        border-radius: 4px;
        background: #fafafa;
        padding: 12px 16px;
        font-size: 16px;
        color: #333333;
      }
      .Followup-Appointment {
        display: flex;
        .Followup-item {
          width: 50%;
          background: #fafafa;
          border-radius: 4px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 10px 12px;
          font-weight: 500;
          font-size: 16px;
          color: #1b1b1b;
          margin: 0 10px 10px 0;
          .right-text {
            font-weight: 400;
            font-size: 16px;
            color: #999999;
            cursor: pointer;
          }
        }
      }
      .imgs {
        ::v-deep(.ant-image) {
          margin-right: 8px;
          &:last-child {
            margin-right: 0;
          }
        }
      }
      .offline {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-template-rows: repeat(2, 1fr);
        grid-gap: 16px 0;
        border-radius: 4px;
        background: #fafafa;
        margin-bottom: 12px;
        padding: 18px 12px;
        .item {
          .label {
            color: #999999;
            font-size: 14px;
            font-weight: 500;
            margin-right: 8px;
          }
          .value {
            color: #333333;
            font-size: 14px;
            font-weight: 500;
          }
        }
        .large {
          grid-column-end: span 3;
        }
      }
    }
  }
}
</style>
